module.exports = __webpack_public_path__ + "img/poster-header.ab22da9a.png";